import { createI18n } from 'vue-i18n';

import en from "@/locales/translations/en.json"
import de from "@/locales/translations/de.json"
import fr from "@/locales/translations/fr.json"

const browserLanguage = navigator.language.split('-')[0]; // z.B. "de" für "de-DE"
const defaultLocale = ['en', 'de', 'fr'].includes(browserLanguage) ? browserLanguage : 'en';

const i18n = createI18n({
    locale: defaultLocale,
    fallbackLocale: "en",
    messages: { de, en, fr },
    legacy: false,
    warnHtmlMessage: false
})

export function getCurrentLanguage() {
    return i18n.global.locale.value;
}

export function useTranslation(store) {
    // Greife direkt auf i18n.global zu, um die $t-Methode zu verwenden
    const translate = (key, options = {}) => {
        return i18n.global.t(key, options);
    };

    // Funktion zum Ändern der Sprache
    const changeLanguage = (newLocale) => {
        i18n.global.locale.value = newLocale;

        if (store !== null) {
            store.actions.changeLanguage(newLocale);
        }
    };

    const getLanguage = () => {
        return i18n.global.locale.value;
    }

    return {
        translate,

        getLanguage,
        changeLanguage
    };
}

export default i18n;